<!-- eslint-disable i18next/no-literal-string -->
<!-- eslint-disable vue/no-v-html -->
<template>
  <b-popover
    id="legendLiveStreaming"
    ref="legendLiveStreaming"
    target="legend-info-icon"
    custom-class="mc-trackvision-live-streaming__legend-wrapper"
    triggers="blur"
  >
    <div class="mc-trackvision-live-streaming__legend-header">
      <h3>{{ $t('trackVideo.legend.title') }}</h3>
      <i class="mc-fa icon-outline_close" @click="$emit('close')"></i>
    </div>
    <div class="mc-trackvision-live-streaming__legend-description">
      <i class="mc-fa icon-fill_info" />
      <p v-html="$t('trackVideo.legend.description')"></p>
    </div>
    <div class="mc-trackvision-live-streaming__legend-content">
      <div class="mc-trackvision-live-streaming__legend-content-item">
        <h5>{{ $t('trackVideo.legend.videoStatus') }}</h5>
        <div class="mc-trackvision-live-streaming__legend-list-status-wrapper">
          <div class="mc-trackvision-live-streaming__legend-video-status-wrapper">
            <span class="mc-trackvision-live-streaming__video-status-badge online">
              <i class="mc-fa icon-fill_video" />
              ONLINE
            </span>
            <p class="mc-trackvision-live-streaming__label-status">Video Online</p>
          </div>
          <div class="mc-trackvision-live-streaming__legend-video-status-wrapper">
            <span class="mc-trackvision-live-streaming__video-status-badge offline">
              <i class="mc-fa icon-fill_video" />
              OFFLINE
            </span>
            <p class="mc-trackvision-live-streaming__label-status">Video Offline</p>
          </div>
        </div>
      </div>
      <div class="mc-trackvision-live-streaming__legend-content-item">
        <h5>{{ $t('trackVideo.legend.motionStatus') }}</h5>
        <div class="mc-trackvision-live-streaming__legend-list-status-wrapper">
          <template v-for="(item, index) in motionList">
            <div :key="index" class="mc-trackvision-live-streaming__legend-video-status-item">
              <i
                :class="`mc-fa icon-fill_car mc-trackvision-live-streaming__video-status-icon ${item.classColor}`"
              />
              <p>{{ item.label }}</p>
            </div>
          </template>
        </div>
      </div>
    </div>
  </b-popover>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'LegendLiveStreaming',
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
    }),
    motionList() {
      return [
        {
          classColor: 'moving',
          label: this.$t('global.filter.running'),
        },
        {
          classColor: 'idle',
          label: this.$t('global.filter.idle'),
        },
        {
          classColor: 'parking',
          label: this.$t('global.filter.parking'),
        },
        ...(this.hasAccess(['assisted_motion_status:read'])
          ? [
              {
                classColor: 'assisted',
                label: this.$t('global.filter.assisted'),
              },
            ]
          : []),
        {
          classColor: 'offline',
          label: this.$t('global.filter.offline'),
        },
      ]
    },
  },
}
</script>
